<template>
  <div>
    <div class="session-timeout-card">
      <div class="card-header">
<!--        <h3 class="card-title">Session Timeout Settings</h3>-->
        <p class="card-subtitle">Manage user session duration</p>
      </div>
      <div class="card-body">
        <div class="switch-container">
          <h4>Enable Session Timeout</h4>
          <label class="switch">
            <input type="checkbox" v-model="isSessionTimeoutEnabled" @change="updateSessionTimeout">
            <span class="slider"></span>
          </label>
        </div>

        <div class="timeout-display">
          <p>Current Timeout: <strong>{{ sessionTimeout }} minutes</strong></p>
        </div>

        <div class="actions">
          <button class="btn btn-primary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
            <i class="fas fa-clock"></i> Set Timeout
          </button>
        </div>

        <div class="collapse" id="collapseExample">
          <div class="time-selectors-container">
            <label for="sessionTimeout">Set session timeout:</label>
            <div class="time-selectors">
              <div class="time-selector">
                <select v-model="selectedDays" @change="updateSessionTimeout">
                  <option v-for="day in days" :key="day" :value="day">{{ day }}d</option>
                </select>
              </div>
              <div class="time-selector">
                <select v-model="selectedHours" @change="updateSessionTimeout">
                  <option v-for="hour in hours" :key="hour" :value="hour">{{ hour }}h</option>
                </select>
              </div>
              <div class="time-selector">
<!--                <select v-model="selectedMinutes" @change="updateSessionTimeout">-->
<!--                  <option -->
<!--                      v-for="minute in validMinutes" -->
<!--                      :key="minute" -->
<!--                      :value="minute" -->
<!--                      :disabled="minute < 1 && (calculatedSessionTimeout - selectedMinutes + minute < 1)"-->
<!--                  >-->
<!--                    {{ minute }}m-->
<!--                  </option>-->
<!--                </select>-->

                <select v-model="selectedMinutes" @change="updateSessionTimeout">
                  <option
                      v-for="minute in validMinutes"
                      :key="minute"
                      :value="minute"
                      :disabled="minute < 15 && (calculatedSessionTimeout - selectedMinutes + minute < 15)"
                  >
                    {{ minute }} m
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

<!--    <div class="switch-container">-->
<!--      <h3>Switch on session timeout</h3>-->
<!--      <label class="switch">-->
<!--        <input type="checkbox" v-model="isSessionTimeoutEnabled" @change="updateSessionTimeout">-->
<!--        <span class="slider"></span>-->
<!--      </label>-->
<!--    </div>-->
<!--    <div>-->
<!--      <p>Current timeout: {{ sessionTimeout }} minutes</p>-->
<!--    </div>-->
<!--    <p>-->
<!--      <button class="btn btn-primary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">-->
<!--        Select Session Timeout-->
<!--      </button>-->
<!--    </p>-->
<!--    <div class="collapse" id="collapseExample">-->
<!--      <label for="sessionTimeout">Set session timeout:</label>-->
<!--      <div class="time-selectors">-->
<!--        &lt;!&ndash; Days Dropdown &ndash;&gt;-->
<!--        <select v-model="selectedDays" @change="updateSessionTimeout">-->
<!--          <option v-for="day in days" :key="day" :value="day">{{ day }} day(s)</option>-->
<!--        </select>-->

<!--        &lt;!&ndash; Hours Dropdown &ndash;&gt;-->
<!--        <select v-model="selectedHours" @change="updateSessionTimeout">-->
<!--          <option v-for="hour in hours" :key="hour" :value="hour">{{ hour }} hour(s)</option>-->
<!--        </select>-->

<!--        &lt;!&ndash; Minutes Dropdown &ndash;&gt;-->
<!--        <select v-model="selectedMinutes" @change="updateSessionTimeout">-->
<!--          <option-->
<!--              v-for="minute in validMinutes"-->
<!--              :key="minute"-->
<!--              :value="minute"-->
<!--              :disabled="minute < 1 && (calculatedSessionTimeout - selectedMinutes + minute < 1)"-->
<!--          >-->
<!--            {{ minute }} minute(s)-->
<!--          </option>-->
<!--        </select>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      days: Array.from({ length: 3 }, (_, i) => i),  // Days: 1 to 2 (maximum of 2 days)
      hours: Array.from({ length: 24 }, (_, i) => i), // Hours: 0 to 23
      minutes: Array.from({ length: 60 }, (_, i) => i), // Minutes: 0 to 59
      selectedDays: 0,
      selectedHours: 0,
      selectedMinutes: 15, // Default to 15 minutes
      sessionTimeout: localStorage.getItem('sessionValue'), // Default value
      // isSessionTimeoutEnabled: true,
    };
  },
  computed: {
    // Combined timeout value in minutes
    calculatedSessionTimeout() {
      let totalMinutes = (this.selectedDays * 24 * 60) + (this.selectedHours * 60) + this.selectedMinutes;

      // Enforce minimum time (15 minutes) and maximum time (2 days = 2880 minutes)
      if (totalMinutes < 15) totalMinutes = 15; // Min time: 15 minutes
      if (totalMinutes > 2880) totalMinutes = 2880; // Max time: 2 days (2880 minutes)

      return totalMinutes;
    },
    // Generate the valid minutes options
    validMinutes() {
      const availableMinutes = [];
      // Add minutes from 0 to 59 to the available options
      for (let minute = 0; minute < 60; minute++) {
        if (minute >= 15 || this.calculatedSessionTimeout + minute >= 15) {
          availableMinutes.push(minute);
        }
      }
      return availableMinutes;
    },
    isSessionTimeoutEnabled: {
      get() {
        const itemKey = 'isSessionTimeoutEnabled';
        // Check if the item exists in localStorage
        const storedValue = localStorage.getItem(itemKey);
        // Return the parsed boolean value if it exists, or default to true
        return storedValue !== null ? storedValue === 'true' : true;
      },
      set(value) {
        // Store the updated value in localStorage whenever it changes
        localStorage.setItem('isSessionTimeoutEnabled', value.toString());
      }
    }
  },
  watch: {
    // Watch for changes to calculated session timeout and update sessionTimeout
    calculatedSessionTimeout(newTimeout) {
      this.sessionTimeout = newTimeout;
    }
  },
  created() {
    // Load the current session timeout from localStorage (if set)
    const savedTimeout = localStorage.getItem('sessionTimeout');
    if (savedTimeout) {
      this.sessionTimeout = parseInt(savedTimeout, 10);
    }
  },
  methods: {
    updateSessionTimeout() {
      // Save the session timeout and the enabled state to localStorage
      this.sessionTimeout = this.calculatedSessionTimeout;
      localStorage.setItem('sessionTimeout', this.sessionTimeout);
      // localStorage.setItem('isSessionTimeoutEnabled', this.isSessionTimeoutEnabled.toString());

      if (!this.isSessionTimeoutEnabled) {
        // If the user disables session timeout, clear any existing session timer
        localStorage.removeItem('isSessionTimeoutEnabled');
      }
      window.location.reload();
    },
  }
};
</script>

<style scoped>
.switch-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.switch {
  --button-width: 3.5em;
  --button-height: 2em;
  --toggle-diameter: 1.5em;
  --button-toggle-offset: calc((var(--button-height) - var(--toggle-diameter)) / 2);
  --toggle-shadow-offset: 10px;
  --toggle-wider: 3em;
  --color-grey: #cccccc;
  --color-green: #4296f4;
}

.slider {
  display: inline-block;
  width: var(--button-width);
  height: var(--button-height);
  background-color: var(--color-grey);
  border-radius: calc(var(--button-height) / 2);
  position: relative;
  transition: 0.3s all ease-in-out;
}

.slider::after {
  content: "";
  display: inline-block;
  width: var(--toggle-diameter);
  height: var(--toggle-diameter);
  background-color: #fff;
  border-radius: calc(var(--toggle-diameter) / 2);
  position: absolute;
  top: var(--button-toggle-offset);
  transform: translateX(var(--button-toggle-offset));
  box-shadow: var(--toggle-shadow-offset) 0 calc(var(--toggle-shadow-offset) * 4) rgba(0, 0, 0, 0.1);
  transition: 0.3s all ease-in-out;
}

.switch input[type="checkbox"]:checked + .slider {
  background-color: var(--color-green);
}

.switch input[type="checkbox"]:checked + .slider::after {
  transform: translateX(calc(var(--button-width) - var(--toggle-diameter) - var(--button-toggle-offset)));
  box-shadow: calc(var(--toggle-shadow-offset) * -1) 0 calc(var(--toggle-shadow-offset) * 4) rgba(0, 0, 0, 0.1);
}

.switch input[type="checkbox"] {
  display: none;
}

.switch input[type="checkbox"]:active + .slider::after {
  width: var(--toggle-wider);
}

.switch input[type="checkbox"]:checked:active + .slider::after {
  transform: translateX(calc(var(--button-width) - var(--toggle-wider) - var(--button-toggle-offset)));
}

</style>

<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css');

.session-timeout-card {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  max-width: 420px;
  margin: 40px auto;
  overflow: hidden;
  border: 1px solid #e0e0e0;
}

.card-header {
  background-color: #f8f9fa;
  padding: 24px;
  border-bottom: 1px solid #e0e0e0;
}

.card-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #333;
}

.card-subtitle {
  margin: 4px 0 0;
  font-size: 16px;
  color: #666;
}

.card-body {
  padding: 24px;
}

.switch-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.switch-container h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: #333;
}

.switch {
  --button-width: 3.5em;
  --button-height: 2em;
  --toggle-diameter: 1.5em;
  --button-toggle-offset: calc((var(--button-height) - var(--toggle-diameter)) / 2);
  --toggle-shadow-offset: 10px;
  --toggle-wider: 3em;
  --color-grey: #cccccc;
  --color-green: #28a745;
}

.slider {
  display: inline-block;
  width: var(--button-width);
  height: var(--button-height);
  background-color: var(--color-grey);
  border-radius: calc(var(--button-height) / 2);
  position: relative;
  transition: 0.3s all ease-in-out;
}

.slider::after {
  content: "";
  display: inline-block;
  width: var(--toggle-diameter);
  height: var(--toggle-diameter);
  background-color: #fff;
  border-radius: calc(var(--toggle-diameter) / 2);
  position: absolute;
  top: var(--button-toggle-offset);
  transform: translateX(var(--button-toggle-offset));
  box-shadow: var(--toggle-shadow-offset) 0 calc(var(--toggle-shadow-offset) * 4) rgba(0, 0, 0, 0.1);
  transition: 0.3s all ease-in-out;
}

.switch input[type="checkbox"]:checked + .slider {
  background-color: var(--color-green);
}

.switch input[type="checkbox"]:checked + .slider::after {
  transform: translateX(calc(var(--button-width) - var(--toggle-diameter) - var(--button-toggle-offset)));
  box-shadow: calc(var(--toggle-shadow-offset) * -1) 0 calc(var(--toggle-shadow-offset) * 4) rgba(0, 0, 0, 0.1);
}

.switch input[type="checkbox"] {
  display: none;
}

.switch input[type="checkbox"]:active + .slider::after {
  width: var(--toggle-wider);
}

.switch input[type="checkbox"]:checked:active + .slider::after {
  transform: translateX(calc(var(--button-width) - var(--toggle-wider) - var(--button-toggle-offset)));
}

.timeout-display {
  background-color: #f1f3f5;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  margin-bottom: 24px;
}

.timeout-display p {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.timeout-display strong {
  font-weight: 600;
  color: #007bff;
}

.actions {
  text-align: center;
  margin-bottom: 24px;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  padding: 12px 24px;
  border-radius: 8px;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

.btn-primary:hover {
  background-color: #0056b3;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.2);
}

.btn-primary i {
  margin-right: 8px;
}

.collapse {
  padding-top: 16px;
}

.time-selectors-container {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #e0e0e0;
}

.time-selectors-container label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 16px;
}

.time-selectors {
  display: flex;
  gap: 12px;
}

.time-selector {
  flex: 1;
}

.time-selectors select {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #ced4da;
  background-color: #fff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.time-selectors select:focus {
  outline: none;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
}
</style>
